import { BannerName } from '@/components/Banners/Banners.types';

export const TOP_BANNER_HEIGHT = 100;

export const ADRIVER_SID = '220545';

export const AdriverBannerId = {
  [BannerName.Top]: 'js-lotriver-top-banner',
  [BannerName.TopDesktop]: 'js-lotriver-top-banner',
  [BannerName.Bottom]: 'js-lotriver-bottom-banner4',
  [BannerName.Background]: 'js-lotriver-bg-banner',
  [BannerName.InListDesktop]: 'js-lotriver-in-list-desktop-banner',
  [BannerName.Catfish]: 'catfish',
};

export const AdManagerBanners = {
  [BannerName.TopDesktop]: {
    bannerId: '/22595893243/Top_desk_tap.az',
    blockId: 'google-buds-top-banner',
    sizes: [2000, 120],
  },
  [BannerName.Top]: {
    bannerId: '/22595893243/tap.az/tap.az_mobile_top',
    blockId: 'google-buds-top-banner',
    sizes: [320, TOP_BANNER_HEIGHT],
  },
  [BannerName.Bottom]: {
    bannerId: '/22595893243/tap.az/mobile_bottom_tap.az',
    blockId: 'google-buds-bottom-banner',
    sizes: [320, 100],
  },
  [BannerName.BackgroundLeft]: {
    bannerId: '/22595893243/tap.az/Tap.az_Background_left',
    blockId: 'google-buds-bg-banner-left',
    sizes: [230, 1000],
  },
  [BannerName.BackgroundRight]: {
    bannerId: '/22595893243/tap.az/Tap.az_Background_right',
    blockId: 'google-buds-bg-banner',
    sizes: [230, 1000],
  },
  [BannerName.Catfish]: {
    bannerId: '/22595893243/tap.az/tap.az_catfish_desk',
    blockId: 'google-buds-banner-catfish',
    sizes: [700, 120],
  },
};
